(()=>{
  function init(root){
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const ticker=root.querySelector('.ticker');
    const tickerToggle=root.querySelector('.ticker-toggle');
    tickerToggle?.addEventListener('click',()=>{
      const paused=ticker.classList.toggle('is-paused');
      tickerToggle.setAttribute('aria-pressed',String(paused));
      tickerToggle.setAttribute('aria-label',paused?'Resume scrolling ingredients':'Pause scrolling ingredients');
      tickerToggle.textContent=paused?'▶':'Ⅱ';
    });
    const stage=root.querySelector('.peel-stage');
    const banana=root.querySelector('.banana-button');
    const toggle=root.querySelector('.peel-toggle');
    function setOpen(open){
      stage.classList.toggle('open',open);
      stage.querySelector('.ingredient-notes').setAttribute('aria-hidden',String(!open));
      toggle.setAttribute('aria-expanded',String(open));
      banana.setAttribute('aria-expanded',String(open));
      banana.setAttribute('aria-label',open?'Close the banana peel':'Peel the banana to reveal the ingredients');
      toggle.textContent=open?'Peel it back again ↶':'Peel me open ↗';
    }
    setOpen(false);
    for(const button of [banana,toggle])button.addEventListener('click',()=>setOpen(!stage.classList.contains('open')));
    root.querySelectorAll('.preview-form').forEach(form=>form.addEventListener('submit',event=>{
      event.preventDefault();
      form.querySelector('.form-note').textContent='This is a preview, so your email hasn’t been saved. Follow @getnanawater on TikTok for now!';
    }));
    root.querySelectorAll('.shirt-preview').forEach(button=>{
      let pinned=false;
      function show(front){
        button.classList.toggle('is-front',front);
        button.setAttribute('aria-pressed',String(front));
        button.setAttribute('aria-label',front?'Show back of the NANA Water shirt':'Show front of the NANA Water shirt');
        button.querySelector('.shirt-front').setAttribute('aria-hidden',String(!front));
        button.querySelector('.shirt-back').setAttribute('aria-hidden',String(front));
        button.querySelector('.shirt-hint').textContent=front?'Front design · Tap to flip ↶':'Hover or tap to see the front ↗';
      }
      button.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')show(true);});
      button.addEventListener('pointerleave',()=>show(pinned));
      button.addEventListener('click',()=>{pinned=!button.classList.contains('is-front');show(pinned);});
    });
    root.querySelectorAll('.hat-preview').forEach(button=>{
      let pinned=false;
      function show(back){
        button.classList.toggle('is-back',back);
        button.setAttribute('aria-pressed',String(back));
        button.setAttribute('aria-label',back?'Show front of the NANA Water hat':'Show back of the NANA Water hat');
        button.querySelector('.hat-back').setAttribute('aria-hidden',String(!back));
        button.querySelector('.hat-front').setAttribute('aria-hidden',String(back));
        button.querySelector('.shirt-hint').textContent=back?'Back design · Tap to flip ↶':'Hover or tap to see the back ↗';
      }
      button.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')show(true);});
      button.addEventListener('pointerleave',()=>show(pinned));
      button.addEventListener('click',()=>{pinned=!button.classList.contains('is-back');show(pinned);});
    });
    root.querySelectorAll('.bag-preview').forEach(button=>{
      let pinned=false;
      function show(side){
        button.classList.toggle('is-side',side);
        button.setAttribute('aria-pressed',String(side));
        button.setAttribute('aria-label',side?'Show front of the NANA Water grocery bag':'Show side of the NANA Water grocery bag');
        button.querySelector('.bag-side').setAttribute('aria-hidden',String(!side));
        button.querySelector('.bag-front').setAttribute('aria-hidden',String(side));
        button.querySelector('.shirt-hint').textContent=side?'Side view · Tap to flip ↶':'Hover or tap to see the side ↗';
      }
      button.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')show(true);});
      button.addEventListener('pointerleave',()=>show(pinned));
      button.addEventListener('click',()=>{pinned=!button.classList.contains('is-side');show(pinned);});
    });
    const ripeness=root.querySelector('.ripeness-display');
    if(ripeness){
      const current=Math.min(4,Math.max(1,Number(ripeness.dataset.stage)||1));
      const names=['Idea','Recipe development','Packaging','First batch'];
      const headlines=['Early days. Big ideas.','Finding our flavor.','Dressing the bunch.','The first sip is here.'];
      const captions=['The idea is growing. The first sip is ahead.','Our simple blend is taking shape.','Getting NANA Water ready for its debut.','A new chapter for the bunch.'];
      ripeness.setAttribute('aria-label',`Launch progress: ${names[current-1]}, ${current} of 4 milestones`);
      ripeness.querySelector('strong').textContent=headlines[current-1];
      ripeness.querySelector('.ripeness-caption').textContent=captions[current-1];
      ripeness.querySelectorAll('.ripeness-scale li').forEach((item,i)=>{
        item.classList.toggle('is-current',i===current-1);item.classList.toggle('is-complete',i<current-1);
        if(i===current-1)item.setAttribute('aria-current','step');else item.removeAttribute('aria-current');
      });
      const steps=root.querySelectorAll('.ripening-steps details');
      steps.forEach((step,i)=>{
        step.querySelector('summary b').textContent=i<current-1?'COMPLETE':i===current-1?'WE’RE HERE':'AHEAD';
        step.open=i===current-1;
      });
      if(current>1){
        const intro=root.querySelector('.ripening-section>div>p:last-of-type');
        if(intro)intro.textContent='Growing one milestone at a time. Follow along as NANA Water takes shape.';
      }
      try{
        const previous=Number(localStorage.getItem('nana-last-milestone'));
        if(previous&&previous<current){
          const message=ripeness.querySelector('.ripeness-return');
          message.textContent=`A little riper since your last visit. We’re now at ${names[current-1].toLowerCase()}.`;message.hidden=false;
        }
        localStorage.setItem('nana-last-milestone',String(current));
      }catch{}
    }
    const popup=root.querySelector('.signup-popup');
    if(!popup)return;
    const sessionKey='nana-signup-seen';
    const subscribedKey='nana-signup-complete';
    const stored=(key,session=false)=>{try{return (session?sessionStorage:localStorage).getItem(key)==='yes';}catch{return false;}};
    const remember=(key,session=false)=>{try{(session?sessionStorage:localStorage).setItem(key,'yes');}catch{}};
    let seen=stored(sessionKey,true),ready=false,opener=null;
    function openPopup(trigger){
      if(popup.open||!root.isConnected)return;
      opener=trigger||document.activeElement;
      seen=true;remember(sessionKey,true);
      popup.showModal();document.body.classList.add('nana-popup-open');
    }
    function closePopup(){popup.close();}
    root.querySelectorAll('a[href="#bunch"]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();openPopup(link);}));
    popup.querySelector('.popup-close').addEventListener('click',closePopup);
    popup.querySelector('.popup-later').addEventListener('click',closePopup);
    popup.addEventListener('click',event=>{
      const r=popup.getBoundingClientRect();
      if(event.target===popup&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom))closePopup();
    });
    popup.addEventListener('close',()=>{document.body.classList.remove('nana-popup-open');if(opener?.isConnected)opener.focus({preventScroll:true});});
    function maybeInvite(){
      if(!root.isConnected){cleanup();return;}
      if(!ready||seen||document.hidden||stored(subscribedKey)||document.querySelector('dialog[open]'))return;
      const active=document.activeElement;
      if(active?.matches('input,textarea,select,iframe,[contenteditable="true"]'))return;
      const social=root.querySelector('#behind-bunch')?.getBoundingClientRect();
      if(social&&social.top<innerHeight&&social.bottom>0)return;
      const signup=root.querySelector('#bunch').getBoundingClientRect();
      if(signup.top<innerHeight&&signup.bottom>0)return;
      if(scrollY<Math.max(250,(document.documentElement.scrollHeight-innerHeight)*.22))return;
      openPopup();cleanup();
    }
    const timer=setTimeout(()=>{ready=true;maybeInvite();},18000);
    function cleanup(){clearTimeout(timer);window.removeEventListener('scroll',maybeInvite);document.removeEventListener('visibilitychange',maybeInvite);}
    window.addEventListener('scroll',maybeInvite,{passive:true});
    document.addEventListener('visibilitychange',maybeInvite);
    if(root.querySelector('[data-signup-success]')){remember(subscribedKey);seen=true;cleanup();}
    if(popup.querySelector('[data-signup-success],[data-signup-error]'))openPopup();

  }
  document.querySelectorAll('.nana').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.nana').forEach(init));
})();
